const someParam = 'testing';
const incomingDateFormat = 'MM/dd/yyyy';

class OpsEnums {
  static projectJobs: string[] = [];
  static budgetTypes: string[] = [];
  static marketSegments: string[] = [];
  static purposes: string[] = [];
  static services: string[] = [];

  public static async getEnums() {
    // //should have a direct channel to enums from the database
    const enums: any = {};
    // = await comManager.request(Channel.ENUM_GET_ALL, '60511121e7eb9e8c23d855ff').then((result) => {return result});
    //let enums : any = await comManager.request(Channel.ENUM_GET_ALL, 'whatever').then((result) => {return result});

    OpsEnums.projectJobs = enums.projectJob;
    OpsEnums.purposes = enums.purpose;
    OpsEnums.services = enums.service;
    OpsEnums.budgetTypes = enums.budgetType;
    OpsEnums.marketSegments = enums.marketSegment;
  }

  //web only
  public static setEnums(enums: any) {
    OpsEnums.projectJobs = enums.projectJob;
    OpsEnums.purposes = enums.purpose;
    OpsEnums.services = enums.service;
    OpsEnums.budgetTypes = enums.budgetType;
    OpsEnums.marketSegments = enums.marketSegment;
  }

  public static getprojectJobs() {
    return OpsEnums.projectJobs;
  }
  public static getProjectPurposes() {
    return OpsEnums.purposes;
  }
  public static getServices() {
    return OpsEnums.services;
  }
  public static getBudgetTypes() {
    return OpsEnums.budgetTypes;
  }
  public static getMarketSegments() {
    return OpsEnums.marketSegments;
  }
}

export { someParam, incomingDateFormat, OpsEnums };
